import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Login } from 'src/app/models/login.model';
import { User } from 'src/app/models/payx/user.model';
import { AuthPayxService } from 'src/app/services/payx/authPayx.service';

@Component({
  selector: 'app-payx-user-login',
  templateUrl: './payx-user-login.component.html',
  styleUrls: ['./payx-user-login.component.scss']
})
export class PayxUserLoginComponent implements OnInit {

  registerToggle: boolean = false;
  registerForm: FormGroup;
  interval:any;
  timeLeft:number=10;
  showTimeLeft:boolean=true;
  booleanForCode:boolean=false;
  successToggle:boolean=false;
  login: Login = new Login();
  loginIsValid: boolean = true;
  errorMessage: string = "";
  loadingToggle:boolean=false;



  constructor(
    private formBuilder: FormBuilder,
    private auth:AuthPayxService,
    private router:Router,
    private aRoute: ActivatedRoute

  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm()
  {
    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastname: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
      phoneNumber: ['', [Validators.required, Validators.minLength(8)]],
    });
  }


  toggle()
  {
    this.registerToggle = true
  }
  toggleBack()
  {
    this.registerForm.reset()
    this.registerToggle = false

  }
  startTimer() {
    this.showTimeLeft=true;
    this.timeLeft=300;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      }
       else {
        this.showTimeLeft = false;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  getTimeLeft(){
    return new Date(this.timeLeft * 1000).toISOString().substr(14, 5);
  }

  register(){
    var user:User={
      id:-1,
      firstname:this.registerForm.get('firstName').value,
      lastname:this.registerForm.get('lastname').value,
      phone:this.registerForm.get('phoneNumber').value,
      password:this.registerForm.get('password').value
    }
    this.auth.register(user).subscribe(
      res=>{
        this.registerForm.disable()
        this.booleanForCode=true;
        this.startTimer();
        // this.router.navigateByUrl(`physical-user/activate?phone=${this.registerForm.get('phoneNumber').value}`);
      },
      err=>{

      }
    )
  }

  onCodeChanged(){

  }
  onCodeCompleted(event){
    this.auth.activateUser(this.registerForm.get('phoneNumber').value,event).subscribe(
      res=>{
        //
        this.successToggle=true;
      }
    )
  }

  getActivationCode(){
    this.auth.sendActivationCode(this.registerForm.get('phoneNumber').value).subscribe(
      res=>{
        this.startTimer();
      }
    )
  }

  onSubBtnClick() {
    if(this.loadingToggle)
      return
    this.loadingToggle=true;
      this.auth.login(this.login).subscribe(
        res=>{
          var transferID;
          var pxNumber;
          this.aRoute.queryParams.subscribe(params => {
            transferID = params['transferId'];
            pxNumber = params['pxNumber']
        });
            localStorage.setItem("token",res.headers.get('token'))
            localStorage.setItem("tokenr", res.headers.get("refresh_token"));

            if(transferID){
              this.router.navigateByUrl(`px_transfer/${transferID}`);
              return
            }
            else if(pxNumber){
              localStorage.setItem('c2f817aaf4604172039825c35853fec90c03d5f3',"2")
              this.router.navigateByUrl(`ecommerce_pay/webX?pxNumber=${pxNumber}`);
              return
            }
            // this.router.navigateByUrl(`physical-user/activate?phone=${this.login.username}`);
            this.router.navigateByUrl("physical-user/payment-cards");
        },
        err=>{
          if(err.status==302)
            this.router.navigateByUrl(`physical-user/activate?phone=${this.login.username}`);

          this.loginIsValid=false;
          this.loadingToggle=false;
          this.errorMessage='Username or password is incorrect'
        }
      )
  }

  onOkClick(){
    this.login.username=this.registerForm.get('phoneNumber').value;
    this.login.password=this.registerForm.get('password').value;
    this.onSubBtnClick();
  }

}
